export default __webpack_public_path__ + "static/media/page4_1.2cd920eb.png";